import { useContext } from 'react';
import SettingsContext from 'contexts/SettingsContext';
import type { SettingsContextValue } from 'contexts/SettingsContext';

const useLocalSettings = (): SettingsContextValue => useContext(SettingsContext);
export default useLocalSettings;
